import {
  Box,
  Container,
  Grid,
  Skeleton,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProfileLeftBar from '../PersonalInfoPage/components/leftbar/ProfileLeftBar';
import PublicFeed from './components/PublicFeed';
import { useCurrentPageUserId } from '../../../hooks/useCurrentPageUserId';
import { useGetMyGamificationQuery } from '../../../store/apiSlice/gamification/gamificationApi';
import { useGetMeQuery } from '../../../store/apiSlice/userApi';
import ProfileScoreMenu from '../shared-components/profile-score/ProfileScoreMenu';
import { currentLevelPercentage } from '../../../utils/helper/gamification-score-helper';
import { colors } from '../../../theme/theme';
import { PROFILE_PAGE_INCLUDES } from '../PersonalInfoPage/constants/profile-includes';

const MyFeedPage = () => {
  const { state } = useLocation();
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('lg'));
  const { isOwnPage } = useCurrentPageUserId();

  const { data: gamification, isLoading: isGamificationLoading } =
    useGetMyGamificationQuery();

  // Load current user once for the home feed so ProfileCard has data instead of staying in skeleton state.
  const { data: meUser } = useGetMeQuery(PROFILE_PAGE_INCLUDES);

  const navigate = useNavigate();

  useEffect(() => {
    if (state?.scrollTop) {
      window.scrollTo(0, 0);
    }
  }, [state]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="fit-content"
      sx={{
        width: '100%',
      }}
    >
      <Box
        display="flex"
        color="#DDE1E8"
        maxWidth="1440px"
        width="100%"
        alignSelf="center"
        flexDirection={mobileView ? 'column' : 'row'}
      >
        <ProfileLeftBar
          styles={{ mt: 0 }}
          navigatePhotos={() => navigate(`/me?tab=${4}`)}
          navigateVideos={() => navigate(`/me?tab=${5}`)}
          user={meUser}
        />
        <Box
          className="profile-info-page-main-content"
          flex={2}
          display="flex"
          flexDirection="column"
          mt={{ xs: '16px', lg: 0 }}
          sx={mobileView ? { padding: 0 } : {}}
        >
          <Box width={'100%'}>
            <Container
              disableGutters
              className="profile-tab-container"
              maxWidth={false}
            >
              <Grid container columnGap={{ lg: '16px', xl: '22px' }}>
                <Grid
                  item
                  className="profile-tab-content"
                  flex={1}
                  width="100%"
                  minWidth="1px" // required
                  sx={mobileView ? { order: 1 } : {}}
                >
                  <PublicFeed />
                </Grid>

                <Grid
                  item
                  className="profile-tab-rightbar"
                  width="100%"
                  maxWidth={{ lg: 236, xl: 314 }}
                  height="fit-content"
                  sx={
                    mobileView
                      ? { order: 0, width: '100%', marginBottom: '20px' }
                      : {}
                  }
                >
                  {isOwnPage && (
                    <Stack sx={{ bgcolor: colors.white }}>
                      {isGamificationLoading ? (
                        skeletonProfileScoreHeader
                      ) : (
                        <ProfileScoreMenu
                          points={gamification?.profileScore?.totalCount ?? 0}
                          percentage={currentLevelPercentage(
                            gamification?.profileScore?.totalCount ?? 0
                          )}
                          profileScoreCategory={
                            gamification?.profileScoreCategories ?? []
                          }
                        />
                      )}
                    </Stack>
                  )}
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MyFeedPage;

const skeletonProfileScoreHeader = (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.375rem',
      p: { xs: '22px 16px', lg: '0' },
    }}
  >
    <Skeleton
      variant="rectangular"
      sx={{
        width: '100%',
        height: '2rem',
      }}
    />
    <Skeleton
      variant="rectangular"
      sx={{
        width: '100%',
        height: '25rem',
      }}
    />
  </Box>
);
